import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
	selector: 'app-send-feedback',
	templateUrl: './send-feedback.component.html',
	styleUrls: ['./send-feedback.component.scss']
})
export class SendFeedbackComponent implements OnInit {

	constructor(
		public commonService: CommonService,
		private storageService: StorageService,
	) { }

	ngOnInit(): void {
	}

	feedback_data: any = {
		query: "",
		description: "",
		query_image: "",
		query_image_name: "",
		criticality: ""
	};
	feedback_data_errors: any = {
		query: false,
		description: false,
		query_image: false,
		criticality: false
	};

	uploadAttachment(event) {
		this.feedback_data.query_image = event.target.files[0];
		this.feedback_data.query_image_name = event.target.files[0].name;
	}

	submit_feedback_loader: boolean = false;
	submitFeedback() {
		if (this.feedback_data.query != "" && this.feedback_data.query != null) {
			this.feedback_data_errors.query = false;
		} else {
			this.feedback_data_errors.query = true;
		}

		if (this.feedback_data.description != "" && this.feedback_data.description != null) {
			this.feedback_data_errors.description = false;
		} else {
			this.feedback_data_errors.description = true;
		}

		// if (this.feedback_data.query_image_name != "" && this.feedback_data.query_image_name != null) {
		// 	this.feedback_data_errors.query_image = false;
		// } else {
		// 	this.feedback_data_errors.query_image = true;
		// }

		if (this.feedback_data.criticality != "" && this.feedback_data.criticality != null) {
			this.feedback_data_errors.criticality = false;
		} else {
			this.feedback_data_errors.criticality = true;
		}

		if (
			this.feedback_data_errors.query == false &&
			this.feedback_data_errors.description == false &&
			// this.feedback_data_errors.query_image == false &&
			this.feedback_data_errors.criticality == false
		) {
			this.submit_feedback_loader = true;
			const formData = new FormData();
			formData.append("query", this.feedback_data.query);
			formData.append("description", this.feedback_data.description);
			formData.append("query_image", this.feedback_data.query_image);
			formData.append("query_image_filename", this.feedback_data.query_image_name);
			formData.append("criticality", this.feedback_data.criticality);

			const user_details = this.storageService.get("user_details");
			if (!user_details) {
				formData.append("user", null);
			} else {
				formData.append("user", user_details.id);
			}

			this.commonService.postData('/feedback/', formData).subscribe(
				(res: any) => {
					this.commonService.showToast('success', 'Feedback has been submitted Successfully.');
					this.feedback_data = {
						query: "",
						description: "",
						query_image: "",
						query_image_name: "",
						criticality: ""
					};
					this.feedback_data_errors = {
						query: false,
						description: false,
						query_image: false,
						criticality: false
					};
					this.submit_feedback_loader = false;
				},
				(err) => {
				  this.commonService.showToast('error', err.error);
				  this.submit_feedback_loader = false;
				},
			  );
		}



	}

}
